var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1515_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 17.0707L19.7083 10.8374C20.3833 10.5457 20.3833 9.59573 19.7083 9.30407L5.16667 3.07073C4.61667 2.82907 4.00833 3.2374 4.00833 3.82907L4 7.67073C4 8.0874 4.30833 8.44573 4.725 8.49573L16.5 10.0707L4.725 11.6374C4.30833 11.6957 4 12.0541 4 12.4707L4.00833 16.3124C4.00833 16.9041 4.61667 17.3124 5.16667 17.0707Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_1096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d92b8549a0313fcca821196873d145ce.svg";
export { ForwardRef as ReactComponent };